import React, { useContext, useEffect, useRef, useState } from 'react';
import './ShoppingCart.css'
import shopImage from './../../public/image/shopping-cart.png'
import Image from '../shared/Image';
import MainContext from '../../context/mainContext';
import ShoppingItem from '../shoppingCart/ShoppingItem';
import { priceFormat } from '../../util/showPriceFormat';
import config from './../../config.json';
import { createOrder } from '../../service/orderService';
import toast from 'react-hot-toast';
import IconLoading from '../shared/IconLoading';
import { useNavigate } from 'react-router-dom';
import ConfirmOrderModal from '../shared/ConfirmOrderModal';
import { charsNormalize } from '../../util/charactorsNormalize';
import { updateUserAddressBySelf, updateUserRegionBySelf } from '../../service/userService';
import getUnits from '../../util/productsUnit';
import { cleanFloat } from '../../util/cleanFloat';
import { requestCanceller } from '../../service/axiosCancelToken';
import { getAllArea } from '../../service/areaService';


const ShoppingCart = () => {

    const context = useContext(MainContext);
    const { shoppingCart: items } = context
    const [showInfo, setShowInfo] = useState(context.factureInfo ? true : false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const navigate = useNavigate();
    const [userAddressWriteMode, setUserAddressWriteMode] = useState(false);
    const [address, setAddress] = useState();
    const [units] = useState(getUnits())

    const [placeHolderColor, setPlaceHolderColor] = useState('text-muted')
    const [regions, setRegions] = useState([]);
    const [sendImmadiate, setSendImmadiate] = useState(false);

    const getTotalPrice = () => {
        let total = 0;
        items.forEach(item => {
            total += cleanFloat(item.price * item.count)
        });
        return total;
    }
    const computeSendCost = () => {
        return (context.loggedIn.region && (!context.loggedIn.region.minOrderPriceForFree || context.loggedIn.region.minOrderPriceForFree > getTotalPrice() || sendImmadiate)) ? context.loggedIn.region.cost : 0;
    }
    const clearShoppingCartHandler = () => {
        context.clearShoppingCart();
    }

    const [maxInfoLength] = useState(180);
    const textInfoRef = useRef(null);
    const elementRef = useRef(null);
    const executeScroll = () => elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const setInfoHandler = (value) => {
        if (value.length > maxInfoLength) {
            return;
        }
        context.setFactureInfo(value)
        localStorage.setItem('info', value)
    }

    const getPreNameUnit = (unit) => {
        let str = 'تعداد';
        units.forEach(item => {
            item.name === unit && (str = item.preName)
        })
        return str;
    }

    const submitOrderHandler = async () => {
        try {
            let targetItems = [];
            items.forEach(item => {
                targetItems.push({
                    _id: item._id,
                    name: item.name,
                    count: item.count,
                    price: item.price,
                    unit: item.unit,
                    incrementalStep: item.incrementalStep,
                    preNameUnit: getPreNameUnit(item.unit)
                })
            })

            setSubmitLoading(true);
            setShowConfirmModal(false)
            const info = {
                customer: {
                    _id: context.loggedIn._id,
                    name: context.loggedIn.name,
                    mobile: context.loggedIn.mobile,
                    areaName: context.loggedIn.region.name,
                    address: context.loggedIn.address,
                    color: context.loggedIn.color
                },
                items: targetItems,
                info: context.factureInfo.trim(),
                messengerName: undefined,
                messengerNumber: undefined,
                sendType: context.loggedIn.region.sendType,
                sendImmadiate: sendImmadiate,
                sendCost: computeSendCost(),
            }
            let { status, data } = await createOrder(info);
            if (status === 201) {
                setSubmitLoading(false);
                toast.success('سفارش با موفقیت ثبت شد')
                clearShoppingCartHandler();
                navigate('/success-order', {
                    state: {
                        factureNumber: data.factureNumber,
                        totalPrice: data.totalPrice,
                        createdAt: data.createdAt,
                    }
                })
            }
        } catch (err) {
            setSubmitLoading(false);
            if (err.response && err.response.status === 401) {
                toast.error('عدم دسترسی مجاز')
                window.location.reload();
            }
            else if (err.response && err.response.status === 402) {
                toast.error('موجودی برخی اقلام کم شده است');
            }
            else if (err.response && err.response.status === 404) {
                toast.error('برخی اقلام یافت نشدند');
            }
            else if (err.response && err.response.status === 403) {
                toast.error(`ساعت کاری بین ${String(err.response.data).split('***')[1]} تا ${String(err.response.data).split('###')[1]} می باشد`);
            }
            else if (err.response && err.response.status === 400) {
                toast.error('عملیات با خطا مواجه شد');
            }
        }
    }

    const handleConfirmUserAddress = async () => {
        try {
            const { status } = await updateUserAddressBySelf({ userId: context.loggedIn._id, address });
            if (status === 201) {
                context.login({ ...context.loggedIn, address })
                setUserAddressWriteMode(false)
                toast.success('آدرس کاربر ویرایش شد')
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                toast.error('عدم دسترسی مجاز');
                navigate('/', { replace: true });
            }
            else if (err.response && err.response.status === 404) {
                toast.error('عملیات غیر مجاز');

            }
            console.log(err);
        }
    }

    const handleConfirmUserRegion = async (event) => {
        try {
            let findedIndex = regions.findIndex(item => item._id === event.target.value)
            context.login({ ...context.loggedIn, region: regions[findedIndex] })
            const { status } = await updateUserRegionBySelf({ userId: context.loggedIn._id, regionId: regions[findedIndex]._id });
            if (status === 201) {
                toast.success('شهر/منطقه تنظیم شد')
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                toast.error('عدم دسترسی مجاز');
                navigate('/', { replace: true });
            }
            else if (err.response && err.response.status === 404) {
                toast.error('عملیات غیر مجاز');

            }
            console.log(err);
        }
    }

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchAllArea = async () => {
            try {
                let { status, data } = await getAllArea({ cancelToken: cancelRequest.signal });
                if (status === 201) {
                    setRegions(data.areas)
                }
            } catch (err) {

            }
        }
        fetchAllArea();
        return () => {
            cancelRequest.cancel();
        }
    }, []);

    return (
        <React.Fragment>
            <header className='shopping-cart-title'>
                <Image
                    src={shopImage}
                    width={40}
                    height={33}
                    style={{ objectFit: 'cover', opacity: '1' }}
                />
                <h5 className='mt-1'>سبد خرید</h5>
            </header>
            {
                items.length ?
                    <div className='shopping-cart-layer'>
                        <section className='col-12 col-md-8 shop-items'>
                            {
                                items.map(item =>
                                    <ShoppingItem
                                        key={item._id}
                                        _id={item._id}
                                        image={item.image}
                                        name={item.name}
                                        price={item.price}
                                        defaultCount={item.count}
                                        inventory={item.inventory}
                                        incrementalStep={item.incrementalStep}
                                        unit={item.unit}
                                        preNameUnit={getPreNameUnit(item.unit)}
                                    />
                                )
                            }
                            <div>
                                <button className='btn btn-secondary  my-3' onClick={clearShoppingCartHandler}>
                                    <i className='fa fa-trash me-2'></i>
                                    خالی کردن سبد خرید
                                </button>

                            </div>
                        </section>
                        <section className='col-12 col-md-4'>
                            <div className='pre-facture'>
                                <header className='fw-bold fs-5'>
                                    پیش فاکتور
                                </header>
                                {
                                    context.loggedIn &&
                                    <section className='' style={{ fontSize: '.9rem' }}>

                                        <div className='d-flex justify-content-between align-items-center mt-2'>
                                            <div>نام مشتری :</div>
                                            <div>{context.loggedIn.name}</div>
                                        </div>

                                        <div className='d-flex justify-content-between align-items-center mt-2'>
                                            <div>شماره تماس :</div>
                                            <div className='ltr'>
                                                {
                                                    context.loggedIn.mobile
                                                }
                                                <span className='mx-1'>
                                                    {(context.loggedIn.phone || context.mobile1) ? '-' : ''}
                                                </span>
                                                {
                                                    context.loggedIn.phone || context.loggedIn.mobile1 || context.loggedIn.mobile2 || context.loggedIn.phone1
                                                }

                                            </div>
                                        </div>
                                        <div className='mt-2' style={{ textAlign: 'justify' }}>
                                            <div className='col-12 my-2'>
                                                <div className="form-floating" dir='rtl'>
                                                    <select
                                                        className={`form-select ${placeHolderColor}`}
                                                        id="selectedRegion"
                                                        aria-readonly={false}
                                                        aria-label="Floating label select example"
                                                        value={context.loggedIn.region ? context.loggedIn.region._id : ''}
                                                        onChange={handleConfirmUserRegion}
                                                        onFocus={() => setPlaceHolderColor('text-dark')}
                                                        style={{ fontSize: '.9rem' }}
                                                    >
                                                        <option hidden >{context.loggedIn.region ? context.loggedIn.region.name : 'انتخاب کنید ...'}</option>
                                                        {
                                                            regions && regions.map((item) => (
                                                                <option key={item._id} value={item._id} label={item.name} />
                                                            ))
                                                        }
                                                    </select>
                                                    <label htmlFor="selectedRegion">
                                                        شهر / منطقه
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mt-2' style={{ textAlign: 'justify' }}>
                                            <div className='col-12 my-2'>
                                                {
                                                    !userAddressWriteMode ?
                                                        <div className=' my-2'>
                                                            آدرس :
                                                            <span className='ms-2 text-secondary'>{context.loggedIn.address}</span>
                                                        </div>
                                                        :
                                                        <div className='info col-12  my-2' style={{ minHeight: '50px' }}>
                                                            <div>
                                                                <label htmlFor="addressInfo" style={{ fontSize: '.75rem', marginBottom: '5px' }}
                                                                >آدرس ( خیابان - کوچه - پلاک - واحد )</label>
                                                                <textarea className="form-control form-control-sm"
                                                                    placeholder="وارد کنید"
                                                                    id="addressInfo"
                                                                    value={address}
                                                                    rows={3}
                                                                    onChange={e => setAddress(charsNormalize(e.target.value))}
                                                                    style={{ width: "100%", fontSize: ".8rem" }}
                                                                />

                                                            </div>
                                                            <button className='btn btn-sm btn-success my-1' type='button'
                                                                onClick={handleConfirmUserAddress}
                                                            >
                                                                تأیید
                                                            </button>
                                                            <button className='btn btn-sm btn-light' onClick={() => {
                                                                setUserAddressWriteMode(false)
                                                                setAddress(context.loggedIn.address)
                                                            }}>انصراف</button>
                                                        </div>
                                                }
                                                {
                                                    !userAddressWriteMode &&
                                                    <button className='btn btn-warning btn-sm mx-auto'
                                                        onClick={() => {
                                                            setAddress(context.loggedIn.address);
                                                            setUserAddressWriteMode(true);
                                                        }}
                                                    >
                                                        <i className='fa fa-pencil' style={{ marginLeft: '7px' }}></i>
                                                        ویرایش آدرس
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                        <div className='facture-info-layer' ref={elementRef}>
                                            {
                                                !showInfo ?
                                                    <button className='btn btn-warning btn-sm mx-auto'
                                                        onClick={() => {
                                                            setShowInfo(true)
                                                            setTimeout(() => {
                                                                textInfoRef.current.focus()
                                                                setTimeout(() => {
                                                                    executeScroll()
                                                                }, 500);
                                                            }, 150);
                                                        }}
                                                    >
                                                        <i className='fa fa-pencil' style={{ marginLeft: '7px' }}></i>
                                                        افزودن توضیحات
                                                    </button>
                                                    :
                                                    <div>
                                                        <textarea
                                                            ref={textInfoRef}
                                                            className="form-control"
                                                            id="info"
                                                            rows="3"
                                                            placeholder="توضیحات"
                                                            value={context.factureInfo}
                                                            name="info"
                                                            aria-describedby="description"
                                                            onChange={(e) => setInfoHandler(e.target.value)}
                                                        ></textarea>
                                                        <div >
                                                            <span>
                                                                {maxInfoLength - context.factureInfo.length}
                                                            </span>
                                                        </div>
                                                    </div>
                                            }
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center mt-3 text-dark fs-6'>
                                            <div>مجموع خرید</div>
                                            <div>{priceFormat(getTotalPrice())} {config.currencyType}</div>
                                        </div>
                                        {
                                            context.loggedIn.region &&
                                            <section className='alert alert-primary py-2 my-2'>
                                                <div className='fw-bold'><i className='fa fa-envelope fs-6 me-1'></i> {context.loggedIn.region.sendType} </div>
                                                <div className="d-flex justify-content-between align-items-center mt-2">
                                                    <div className='text-primary'>ارسال فوری </div>
                                                    <div className="form-check form-switch p-0">

                                                        <input className="form-check-input m-0 mt-2" type="checkbox" id="switch1"
                                                            checked={sendImmadiate}
                                                            onChange={event => {
                                                                setSendImmadiate(event.target.checked)
                                                            }}
                                                        />
                                                        <label className="form-check-label m-0" htmlFor="switch1"></label>
                                                    </div>
                                                </div>

                                                <div className='d-flex justify-content-between align-items-center text-primary '>
                                                    <div>هزینه {context.loggedIn.region.sendType}</div>
                                                    {
                                                        computeSendCost() ?
                                                            <div>{priceFormat(context.loggedIn.region.cost)} ریال</div>
                                                            :
                                                            <div>رایگان</div>
                                                    }
                                                </div>
                                                <div className='' style={{ fontSize: '.8rem' }}>
                                                    {
                                                        (!sendImmadiate && context.loggedIn.region.minOrderPriceForFree && context.loggedIn.region.minOrderPriceForFree > getTotalPrice()) &&
                                                        <small>توجه : جهت استفاده از {context.loggedIn.region.sendType} رایگان ، حداقل مبلغ سفارش باید {priceFormat(context.loggedIn.region.minOrderPriceForFree)} ریال باشد.</small>
                                                    }
                                                </div>
                                                <div className='' style={{ fontSize: '.8rem' }}>
                                                    <small>توجه : مبلغ پیش فرض برای بار با وزن حداکثر {context.loggedIn.region.maxOrderWeigth} کیلوگرم در نظر گرفته شده است.</small>
                                                </div>
                                            </section>
                                        }
                                        <div className='d-flex justify-content-between align-items-center mt-3 text-success fs-6'>
                                            <div>قابل پرداخت</div>
                                            <div>{priceFormat(getTotalPrice() + computeSendCost())} {config.currencyType}</div>
                                        </div>
                                        <div className='text-center mt-3'>
                                            <button className='btn btn-block btn-success w-50'
                                                onClick={() => setShowConfirmModal(true)}
                                                disabled={submitLoading || (context.loggedIn.status === 'Disable') || !context.loggedIn.region}
                                            >
                                                {
                                                    submitLoading &&
                                                    <IconLoading
                                                        type='spin'
                                                        color={'#fff'}
                                                    />
                                                }
                                                ثبت سفارش
                                            </button>
                                        </div>
                                    </section>
                                }
                            </div>
                        </section>
                        <ConfirmOrderModal
                            show={showConfirmModal}
                            handleClose={() => setShowConfirmModal(false)}
                            onConfirm={submitOrderHandler}
                            defaultMobile={context.loggedIn ? context.loggedIn.mobile : ''}
                        />
                    </div>
                    :
                    <div className='empty-shopping-cart'>
                        <Image
                            src={shopImage}
                            width={200}
                            height={164}
                            style={{ objectFit: 'cover', opacity: '.5' }}
                        />
                        <div className='mt-2'>
                            سبد خرید شما خالی است
                        </div>
                    </div>
            }

        </React.Fragment>
    );
}

export default ShoppingCart;